import { render, staticRenderFns } from "./ot-project-user-details.vue?vue&type=template&id=684a2005&scoped=true&"
import script from "./ot-project-user-details.vue?vue&type=script&lang=ts&"
export * from "./ot-project-user-details.vue?vue&type=script&lang=ts&"
import style0 from "./ot-project-user-details.vue?vue&type=style&index=0&id=684a2005&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684a2005",
  null
  
)

export default component.exports